import { put, select, takeLatest } from 'redux-saga/effects';
import { tableAction, tableActions, tableInitialState } from '../../App/Ducks/Table.duck';
import { getConnectionTasks } from '../Services/ConnectionService';
import { retryTask } from '../Services/TaskService';
import { MESSAGE_SEVERITY_ERROR, MESSAGE_SEVERITY_SUCCESS } from '../../../common/constants';
import { actions as AppActions } from '../../App/Ducks/App.duck';

export const actionTypes = {
  RequestData: '[Tasks] Request',
  FulfilledTable: '[Tasks] Fulfilled',
  SearchTable: '[Tasks] Search',
  ChangePage: '[Tasks] change page',
  SetPageSize: '[Tasks] set page size',
  SortTable: '[Tasks] Sort',
  ApplyFilter: '[Tasks] Apply filter',
  RemoveFilter: '[Tasks] Remove filter',
  SetConnectionId: '[Tasks] Set connection Id',
};

const initialState = {
  ...tableInitialState,
  connectionId: null,
  taskId: null,
};

export const reducer = (state = initialState, action) => {
  const newState = tableAction(actionTypes, state, action);

  switch (action.type) {
    case actionTypes.SetConnectionId: {
      return {
        ...state,
        connectionId: action.connectionId,
      };
    }

    default:
      return newState;
  }
};

export const actions = {
  ...tableActions(actionTypes),
  setConnectionId: connectionId => ({
    type: actionTypes.SetConnectionId,
    connectionId,
  }),
};

export function* saga() {
  function* reloadData() {
    yield put(actions.requestData());
  }

  yield takeLatest(actionTypes.SearchTable, reloadData);
  yield takeLatest(actionTypes.ChangePage, reloadData);
  yield takeLatest(actionTypes.SetPageSize, reloadData);
  yield takeLatest(actionTypes.SortTable, reloadData);
  yield takeLatest(actionTypes.ApplyFilter, reloadData);
  yield takeLatest(actionTypes.RemoveFilter, reloadData);

  yield takeLatest(actionTypes.RequestData, function* request() {
    const currentState = yield select(state => {
      return state.TasksReducer;
    });

    const response = yield getConnectionTasks(
      currentState.connectionId,
      currentState.page,
      currentState.pageSize,
      currentState.sortBy,
      currentState.filters,
      currentState.searchQuery,
    );

    yield put(actions.fulfilled(response.data['hydra:member'], response.data['hydra:totalItems']));
  });
}
